export const getCookie = (name: string) => {
  if (typeof window === "undefined") return undefined;
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

export const setCookie = (
  cookieName: string,
  cookieValue: string,
  domainScoped = false
): void => {
  document.cookie = `${cookieName}=${cookieValue};${
    domainScoped &&
    `domain=.${window.origin.split(".").slice(-2).join(".")}; path=/;`
  }`;
};
